import { render, staticRenderFns } from "./RoyaltyStatement.vue?vue&type=template&id=25d9dbdc"
import script from "./RoyaltyStatement.vue?vue&type=script&lang=js"
export * from "./RoyaltyStatement.vue?vue&type=script&lang=js"
import style0 from "./RoyaltyStatement.vue?vue&type=style&index=0&id=25d9dbdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports